import React, { FC } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import TaxList from "../components/tax/taxList";
import AddEditTax from "../components/tax/addEditTax";
import TaxProducts from "../components/tax/taxProducts";
import ZoneStack from "./zoneStack";

const TaxStack: FC = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator()
    //Variable to handle route params
    return (
        <AppStack.Navigator
            initialRouteName={"TaxList"}
            screenOptions={{ headerShown: false }}>
            <AppStack.Screen name='TaxList' component={TaxList} />
            <AppStack.Screen name='AddEditTax' component={AddEditTax} />
            <AppStack.Screen name='TaxProducts' component={TaxProducts} />
            <AppStack.Screen name='ZoneStack' component={ZoneStack} />
        </AppStack.Navigator>
    )
}

export default TaxStack;